import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { ICreateSpeakerPayload } from '@app-store/slices/speakers/createSpeaker'

interface TaskAction extends Action {
    payload: ICreateSpeakerPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.speakers.create

function* createSpeakerSagaTask({ payload }) {
    try {
        const response = yield axios.post(`/event/speaker`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        console.log(error)
        yield put(onFailure(error))
    }
}

function* createSpeakerSaga(): any {
    yield takeLatest<TaskAction>(onRequest, createSpeakerSagaTask)
}

export default createSpeakerSaga
